// eslint-disable-next-line no-var, import/no-unresolved, import/extensions
var Validation = require('./lib/validation');

module.exports = Validation;
exports = module.exports;
exports.Validation = Validation;
